// extracted by mini-css-extract-plugin
export default {"bar-wrapper":"BarChart_bar-wrapper__eDcQa","bar-container":"BarChart_bar-container__rmpty","fillAnimation":"BarChart_fillAnimation__VboV+","used-bar":"BarChart_used-bar__ugvSD"};